import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBotResponse, messageFormat } from '../../../../utils/helpers';
import { act } from 'react-dom/test-utils';

export const fetchBotResponse = createAsyncThunk(
  'messages/fetchBotResponse',
  async (payload, thunkAPI) => {
    const response = await getBotResponse(payload);
    await new Promise((r) => setTimeout(r, 1000));
    return response;
  }
);

export const resetBot = createAsyncThunk(
  'messages/resetBot',
  async (payload, thunkAPI) => {
    await getBotResponse(payload);
  }
);

const initialState = {
  messages: [],
  cardList: [''],
  botTyping: false,
  userTyping: true,
  userTypingPlaceholder: 'Type your message here...',
  userGreeted: false,
  showDatePicker: false,
  cardType: null,
  travelInfo: {
    destination: '',
    startDate: ''
  },
  humanHandOff: {
    isHuman: false
  },
  progress: ''
};
export const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    addMessage: (state, action) => {
      if (action.payload.sender === 'USER') {
        state.messages = state.messages.map((message) => {
          if (message.type === 'custom') {
            if (message.text) {
              message = {
                text: message.text,
                sender: 'BOT',
                type: 'text',
                ts: message.ts
              };
            }
          }
          if (message.type === 'buttons') {
            message.quick_replies = [];
          }
          return message;
        });
      }
      state.messages.push(action.payload);
    },
    resetMessageState: () => {
      return { ...initialState, userGreeted: true };
    },
    removeAllMessages: (state) => {
      state.messages = [];
    },
    replaceAllMessage: (state, action) => {
      state.messages = action.payload;
    },
    disableButtons: (state, action) => {
      const index = action.payload;
      state.messages[index].callback = false;
    },
    toggleUserTyping: (state, action) => {
      state.userTyping = action.payload;
    },
    toggleBotTyping: (state, action) => {
      state.botTyping = action.payload;
      state.userTypingPlaceholder = action.payload
        ? 'Please wait for bot response...'
        : 'Type your message here...';
    },
    toggleShowDatePicker: (state, action) => {
      state.showDatePicker = action.payload;
    },
    toggleCardType: (state, action) => {
      state.cardType = action.payload;
    },
    toggleProgress: (state, action) => {
      state.progress = action.payload;
    },
    toggleHuman: (state, action) => {
      state.humanHandOff = {
        ...state.humanHandOff,
        isHuman: action.payload
      };
    },
    toggleTravelDate: (state, action) => {
      state.travelInfo = {
        ...state.travelInfo,
        startDate: action.payload
      };
    },
    setUserTypingPlaceholder: (state, action) => {
      state.userTypingPlaceholder = action.payload;
    },
    setUserGreeted: (state, action) => {
      state.userGreeted = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBotResponse.fulfilled, (state, action) => {
      state.botTyping = false;
      state.userTyping = true;
      state.userTypingPlaceholder = 'Type your message here...';
      state.showDatePicker = false;

      // format to new data structure
      let length = action.payload.length;
      let messages = action.payload;
      if (messages[length - 1]?.custom) {
        messages = messageFormat(action.payload);
      }
      if (messages.length > 0) {
        state.botTyping = false;
        state.userTyping = true;
        state.userTypingPlaceholder = 'Type your message here...';
        state.showDatePicker = false;
        for (let index = 0; index < messages.length; index += 1) {
          const message = messages[index];
          // messageType: text

          if (message?.text) {
            if (
              message.text.includes('OK! Your destination travel location is')
            ) {
              let words = message.text.split(' ');
              let des = words[words.length - 1];
              state.travelInfo.destination = des;
              state.progress = 'booking';
            } else if (
              message.text.includes(
                'OK. Please enter your PNR number for the booking'
              )
            ) {
              state.progress = 'cancellation';
            } else if (message.text.includes('How can I help?')) {
              state.progress = '';
            }
            state.messages.push({
              text: message.text,
              sender: 'BOT',
              type: 'text',
              ts: new Date()
            });
          }

          // messageType: image
          if (message?.image) {
            state.messages.push({
              src: message.image,
              sender: 'BOT',
              type: 'image',
              ts: new Date()
            });
          }

          // messageType: buttons
          if (message?.buttons) {
            if (message.buttons.length > 0) {
              state.userTyping = false;
              state.messages.push({
                buttons: message.buttons,
                sender: 'BOT',
                type: 'buttons',
                ts: new Date(),
                callback: true
              });
            }
          }

          // messageType: text
          if (message?.dateText) {
            state.showDatePicker = true;
            state.userTyping = false;
            state.messages.push({
              text: message.dateText,
              sender: 'BOT',
              type: 'text',
              ts: new Date()
            });
          }

          // messageType: card
          if (message?.cardList) {
            state.userTyping = false;
            state.cardList = message.cardList;
            state.cardType = message.cardType;
          }

          // messageType: human
          if (message?.human) {
            state.userTyping = false;
            state.humanHandOff = {
              isHuman: true,
              ...message.human
            };
          }
        }
      } else if (messages === false) {
        state.botTyping = true;
      } else {
        state.messages.push({
          text: "Unfortunately I'm experiencing a problem with your request🙁. Please try again later or refresh and restart this chat.",
          sender: 'BOT',
          type: 'text',
          ts: new Date()
        });
      }
    });
  }
});

export const {
  addMessage,
  removeAllMessages,
  replaceAllMessage,
  toggleBotTyping,
  toggleUserTyping,
  toggleShowDatePicker,
  toggleShowWeather,
  toggleCardType,
  toggleHuman,
  toggleNotification,
  toggleProgress,
  toggleTravelDate,
  setUserTypingPlaceholder,
  setUserGreeted,
  resetMessageState,
  disableButtons
} = messagesSlice.actions;

export default messagesSlice.reducer;
